import { forwardRef } from "react";

/**
 * This component should only be used when you cannot use the native button component
 */
export const AccessibleButton = forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & { onClick?: any }
>((props, ref) => {
  const { onClick, onKeyDown, role = "button", tabIndex = 0, ...rest } = props;

  return (
    <div
      ref={ref}
      role={role}
      tabIndex={tabIndex}
      onKeyDown={(e) => {
        if ((e.code === "Enter" || e.code === "Space") && onClick) {
          onClick(e);
        }
        onKeyDown?.(e);
      }}
      onClick={onClick}
      {...rest}
    >
      {props.children}
    </div>
  );
});

function AccessibleButtonHOC<T>(Component: React.FC<T>) {
  return (
    props: T &
      React.HTMLAttributes<HTMLDivElement> &
      React.HTMLAttributes<HTMLButtonElement>,
  ) => {
    return (
      <button {...props}>
        <Component {...props} />
      </button>
    );
  };
}

export default AccessibleButtonHOC;
